import React from 'react';

import { theme } from 'antd';

const { useToken } = theme;

interface ServiceAlertIconProps {
  width?: number;
  height?: number;
}

const ServiceAlertIcon = ({ width = 16, height = 16, ...rest }: ServiceAlertIconProps) => {
  const { token } = useToken();

  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M0.5 2C0.5 0.895431 1.39543 0 2.5 0H14.5C15.6046 0 16.5 0.895431 16.5 2V14C16.5 15.1046 15.6046 16 14.5 16H2.5C1.39543 16 0.5 15.1046 0.5 14V2Z"
        fill={token.colorInfoBg}
      />
      <path
        d="M7.375 7.94998C7.07522 7.40747 6.95084 6.78543 7.01895 6.16936C7.08706 5.55329 7.34433 4.97344 7.75537 4.50952C8.16642 4.0456 8.71107 3.72039 9.31446 3.57859C9.91785 3.43679 10.5503 3.48536 11.125 3.71763L9.25 5.74966L9.51531 6.98435L10.75 7.24966L12.782 5.37466C13.0143 5.94932 13.0629 6.58182 12.9211 7.1852C12.7793 7.78859 12.4541 8.33324 11.9901 8.74429C11.5262 9.15534 10.9464 9.4126 10.3303 9.48071C9.71424 9.54883 9.09219 9.42444 8.54969 9.12466L5.92187 12.1715C5.71053 12.3829 5.42388 12.5016 5.125 12.5016C4.82611 12.5016 4.53947 12.3829 4.32812 12.1715C4.11678 11.9602 3.99805 11.6736 3.99805 11.3747C3.99805 11.0758 4.11678 10.7891 4.32812 10.5778L7.375 7.94998Z"
        stroke={token.colorInfo}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ServiceAlertIcon;
